module.exports = __webpack_public_path__ + "img/search.8e18b059.svg";